import type { Quote } from '@facture/contracts'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { documentQuery } from '@/features/documents/api'
import { QuoteEditor } from '@/features/quotes/quote-editor'
import { api } from '@/lib/api'

export const Route = createFileRoute('/_app/quotes/new')({
  staticData: { crumb: 'Nueva' },
  validateSearch: z.object({
    kind: z.enum(['quote', 'recurring']).default('quote'),
    /** Comprobante del que se toman cliente y líneas (p. ej. convertir una factura en recurrente). */
    from: z.string().optional(),
    /** Cotización o plan que se clona. */
    copy: z.string().optional(),
  }),
  loaderDeps: ({ search }) => ({ from: search.from, copy: search.copy }),
  loader: async ({ context, deps }) => ({
    seed: deps.from ? await context.queryClient.ensureQueryData(documentQuery(deps.from)) : null,
    copyOf: deps.copy
      ? await context.queryClient.fetchQuery({
          queryKey: ['quotes', 'detail', deps.copy],
          queryFn: () => api.get<Quote>(`/quotes/${deps.copy}`),
        })
      : null,
  }),
  component: NewQuote,
})

function NewQuote() {
  const { kind } = Route.useSearch()
  const { seed, copyOf } = Route.useLoaderData()
  return (
    <QuoteEditor
      key={`${kind}-${seed?.id ?? ''}-${copyOf?.id ?? ''}`}
      kind={kind}
      seed={seed}
      copyOf={copyOf}
    />
  )
}
